import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },  
    theme: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'First name *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'firstName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Last name *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'lastName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Company',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'clientName',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Email address *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Telephone *',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'telNumber',
            customClasses: ['no-label']
          }
        ]
      },
        {
          fields: [
            {
              type: 'label',
              size: 'Small',
              label: 'Date of Event *',
              mapping: 'headerLabel'
            },
            {
            type: 'date-picker',
            size: 'Large',
            mapping: 'eventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Type of Event *',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            options: [
              { label: 'Teambuilding Event', value: 'Teambuilding Event' },
              { label: 'Sports Team Event', value: 'Sports Team Event' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Social Event', value: 'Social Event' },
              { label: 'Not for profit event', value: 'Not for profit event' },
            ],
            mapping: 'theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Number of guests expected',
            mapping: 'headerLabel'
          },
          {
            type: 'text',
            size: 'Large',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'How did you hear about us *',
            mapping: 'headerLabel'
          },
          {
            type: 'multiple-choice',
            size: 'Large',
            options: [
              { label: 'Search Engine', value: 'Search Engine' },
              { label: 'Social media', value: 'Social media' },
              { label: 'AI Inquiry', value: 'AI Inquiry' },
              { label: 'Word of mouth/referral', value: 'Word of mouth/referral' },
              { label: 'Website listing', value: 'Website listing' },
              { label: 'Other (please specify below)', value: 'Other (please specify below)' },
            ],
            mapping: 'reference',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            label: 'Comments',
            mapping: 'headerLabel'
          },
          {
            type: 'text-area',
            size: 'Large',
            mapping: 'notes',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Small',
            mapping: 'headerLabel',
            customClasses: ['no-label']
          },
          {
            type: 'submit',
            size: 'Large',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Bingemans - Conference Centre Plan a Party Form',
    formId: '2196',
    clientKey: 'CE09530B-9886-4292-A644-85466DC1AFF5',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://bingemans.com/contact-thank-you.php',
    submissionText:'',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
